import { JSX } from 'solid-js';
import { gsap } from 'gsap';
import { useSystemAssets } from '@bz/systemAssets';

import { BetStatus } from '../../types';
import { useBetSlipStore } from '../../useBetSlip';

export function PlaceBetStatusPop(props: { status: BetStatus }): JSX.Element {
  const [_, dispatch, , settingExpanded] = useBetSlipStore();
  const [assets] = useSystemAssets();
  const [countdown, setCountdown] = createSignal(5);

  const closePop = () => {
    dispatch({
      type: 'CHANGE_BET_STATUS',
      status: BetStatus.NORMAL,
    });
  };

  createEffect(() => {
    if (countdown() <= 0) {
      closePop();
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((c) => c - 1);
    }, 1000);

    onCleanup(() => clearTimeout(timer));
  });

  const navigate = useNavigate();

  return (
    <div
      ref={(ref) => {
        createEffect(
          on(
            () => props.status,
            (status, prevStatus) => {
              if (status === BetStatus.SUCCESS && prevStatus !== BetStatus.SUCCESS) {
                const tween = gsap.fromTo(
                  ref,
                  {
                    yPercent: 100,
                    opacity: 0,
                    display: 'flex',
                  },
                  {
                    yPercent: 0,
                    opacity: 1,
                    duration: 0.4,
                    ease: 'power1.inOut',
                  }
                );
                onCleanup(() => {
                  tween.reverse().then(() => {
                    tween.kill();
                  });
                });
              }
              return status;
            }
          )
        );
      }}
      class="w-full hidden bg-betslip-body-bg z-50 flex-col absolute top-32 left-0 right-0 bottom-0"
    >
      <div class="flex-grow center flex-col">
        <img src={assets.successGeneral} class="size-24" alt="Success State" />
        <div class="text-neutral-main1 text-sm font-semibold mt-2">{t('Successfully Bet')}</div>
        <div class="text-neutral-main2 text-sm">{t('Your bet is successfully')}</div>
      </div>

      <div class="flex justify-between gap-2 px-3 pt-3 py-4 caption-l-semibold">
        <Button class="h-10 rounded-lg flex-1 bg-button-general-secondary text-neutral-main1" onClick={closePop}>
          {t('Back')} ({countdown()}s...)
        </Button>

        <Button
          class="h-10 rounded-lg flex-1 w-full"
          type="brand"
          onClick={() => {
            closePop();
            settingExpanded(false);
            navigate('/my-bets');
          }}
        >
          {t('Open Bets')}
        </Button>
      </div>
    </div>
  );
}
